<template>
	<div :class=[outerDivClass]>
		<div v-if="showRp && !showRpPosition" :class=[innerDivClass]>
			<span class="input-group-text">{{ (showRpText ? showRpText :'Rp' )}}</span>
		</div>
		<input type="tel" class="form-control"
		       :placeholder="placeholder"
		       :id="id"
		       v-model="val.formatted"
		       @input="$emit('input', val)"
		>
		<div v-if="showRp && showRpPosition==='right'" :class=[innerDivClass]>
			<span class="input-group-text">{{ (showRpText ? showRpText :'Rp' )}}</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: "InputRupiah",
		props:[
			"outerDivClass",
			"innerDivClass",
			"showRp",
			"placeholder",
			"id",
			"defaultValue",
			"showRpPosition",
			"showRpText",
			"comma",
			"customObject",
			"maxAmount",
		],
		data() {
			return {
				val: {
					formatted: "",
					raw: 0,
				},
			}
		},
		computed: {
			val_formatted() {
				return this.val.formatted
			}
		},
		watch: {
			val_formatted(v) {
				this.getValRupiah(v)
			},
			defaultValue(v) {
				this.getValRupiah(v)
			}
		},
		mounted() {
			if (this.customObject !== undefined) {
				this.val = this.customObject
			}
			this.getValRupiah(this.defaultValue)
		},
		methods: {
			getValRupiah(value) {
				if (this.maxAmount !== undefined) {
					if (parseFloat(value.replace(/\./g, '')) > this.maxAmount) {
						this.val.formatted = this.formatRupiah(this.maxAmount.toString())
						this.val.raw = this.maxAmount
						this.$emit('input', this.val)
						return
					}
				}

				if (value.length === 1 && value == "0"){
					this.val.formatted = ""
					this.val.raw = 0
					return
				}

				var resRegex;
				if (this.comma !== undefined) {
					if (!this.comma) {
						resRegex = value.replace(/[^0-9]+/g, '');
					} else {
						resRegex = value.replace(/[^0-9,]+/g, '');
					}
				} else {
					resRegex = value.replace(/[^0-9,]+/g, '');
				}

				this.val.formatted = this.formatRupiah(resRegex)
				this.getRaw(resRegex)
				this.$emit('input', this.val)
			},
			formatRupiah(angka, prefix){
				// var number_string = angka.replace(/[^,\d]/g, "").toString()
				var split = angka.split(",");
				var sisa = split[0].length % 3;
				var rupiah = split[0].substr(0, sisa)
				var ribuan = split[0].substr(sisa).match(/\d{3}/gi);
				if (ribuan) {
					var separator = sisa ? "." : "";
					rupiah += separator + ribuan.join(".");
				}

				rupiah = split[1] != undefined ? rupiah + "," + split[1].substr(0,2) : rupiah;
				return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
			},
			getRaw(value) {
				this.val.raw = parseFloat(value.replace(",", "."));
				if(isNaN(this.val.raw)){
					this.val.raw=0
				}

			}
		}
	}
</script>